<template>
  <div class="bl_area capture_area">
    <form
      id="frm_cargo"
      @submit.prevent
    >
      <h2 class="content_title">{{ $t('msg.CSBL200.245') }}</h2> <!-- Cargo Information -->

      <table class="tbl_row mt10">
        <colgroup>
          <col style="width:15%">
          <col style="width:18%">
          <col style="width:15%">
          <col style="width:18%">
          <col style="width:15%">
          <col style="width:19%">
        </colgroup>
        <tbody>
          <tr>
            <th>Cargo Weight</th> <!-- Cargo Weight -->
            <td>
              <e-input-number
                v-model="regParams.grsWt"
                :is-comma="true"
                :point="3"
                id="grsWt"
                class="col_6"
                maxlength="14"
                @input="checkValidationInfo('grsWt')"
              >
              </e-input-number> Kgs
            </td>
            <th>{{ $t('art.CMATK098') }}</th> <!-- Measure -->
            <td>
              <e-input-number
                class="dv col_6"
                v-model="regParams.grsCbm"
                id="grsCbm"
                :is-comma="true"
                :point="4"
                maxlength="13"
                @input="checkErrorVisible('grsCbm')"
              >
              </e-input-number>
              CBM
            </td>
            <th>{{ $t('art.CMATK100') }}</th> <!-- Package -->
            <td>
              <e-input-number
                v-model="regParams.pkgQty"
                :is-comma="true"
                id="pkgQty"
                class="col_3"
                maxlength="10"
                @blur="fnPackage('CHANGE')"
                @input="checkValidationInfo('pkgQty')"
              >
              </e-input-number>

              <select
                v-model="regParams.pkgCd"
                id="pkgCd"
                class="inp_space70"
                @change="checkValidationInfo('pkgCd');fnPackage('CHANGE')"
              >
                <option value="">{{ $t('msg.CSBL220.003') }}</option>
                <option v-for="(vo, idx) in pkgCdList" :key="'pkgCd_' + idx" :value="vo.cd">{{ vo.cdNm }}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>

      <h2 class="content_title">Container Information</h2>

      <table class="tbl_col mt10">
        <colgroup>
          <col style="width:3%">
          <col style="width:14%">
          <col style="width:12%">
          <col style="width:22%">
          <col style="width:14%">
          <col style="width:8%">
          <col style="width:8%">
          <col style="width:15%">
          <col style="width:4%">
        </colgroup>
        <thead>
          <tr>
            <th>No.</th>
            <th>{{ $t('msg.CSBL200.197') }}</th> <!-- Container No. -->
            <th>{{ $t('msg.CSBL200.251') }}</th> <!-- Seal No. -->
            <th>HS Code</th>
            <th>{{ $t('msg.ONEX050P060.005') }}</th> <!-- Weight -->
            <th>Measure</th>
            <th>{{ $t('art.CMATK100') }}</th> <!-- Package -->
            <th>Package Code</th>
            <th>
              <button
                v-show="!closeCntr"
                type="button"
                class="tbl_icon plus"
                @click="addBLContainer"
              >
                plus
              </button>
            </th>
          </tr>
        </thead>
        <tbody v-for="(vo, idx) in regParams.houseBlContainerList" :key="'cntr_' + idx">
          <tr>
            <td>{{ idx + 1 }}</td>
            <td>
              <select
                :id="'cntrNo_' + idx"
                v-model="vo.cntrNo"
                @change="checkCntrNo(idx, $event)"
              >
                <option value="select">{{ $t('msg.CSBK100.394') }}</option>
                <option v-for="(cvo, i) in parentInfo.parentRegParams.containerList" :key="'cntr_' + i" :value="cvo.cntrNo">{{ cvo.cntrNo }}</option>
              </select>
            </td>
            <td>
              <!-- WorkingSR/BL 컨테이너에 입력된 Seal No. 표시 전용 (수정 불가) -->
              <div
                class="div_seal"
                v-for="(svo, i) in getSealList(vo.cntrNo)" :key="'hblSeal_' + idx + '_' + i"
              >
                <input
                  type="text"
                  :value="svo.sealNo"
                  disabled
                >
              </div>
            </td>
            <td>
              <div class="tbl_form">
                <span class="dv" style="float: left;width: 40%;">
                  <e-trans-string-check-input
                    :id="'cntrHsCd_' + idx"
                    v-model="vo.hsCd"
                    :is-upper-case="true"
                    :maxlength="'6'"
                    :error-message="vo.hsCdErrorMessage"
                    @input="checkHsCd($event, idx)"
                  />
                </span>
                <span class="dv" style="float: right;width: 60%;">
                  <div class="position_relative">
                    <input type="text"
                           v-model="vo.hsCdNm"
                           :readonly="true"
                    />
                  </div>
                </span>
              </div>
            </td>
            <td>
              <e-input-number
                v-model="vo.wt"
                :id="'wt_' + idx"
                :point="3"
                class="col_7"
                :is-comma="true"
                maxlength="14"
                @input="cntrCheckValidationInfo('wt_' + idx)"
              >
              </e-input-number> Kgs
            </td>
            <td>
              <e-input-number
                v-model="vo.grsCbm"
                :id="'grsCbm_' + idx"
                :is-comma="true"
                :point="4"
                maxlength="8"
                @input="cntrCheckValidationInfo('grsCbm_' + idx)"
              >
              </e-input-number>
            </td>
            <td>
              <e-input-number
                v-model="vo.pkgQty"
                :id="'cntrPkgQty_' + idx"
                :is-comma="true"
                maxlength="10"
                @input="cntrCheckValidationInfo('cntrPkgQty_' + idx)"
              >
              </e-input-number>
            </td>
            <td>
              <select
                :id="'cntrPkgCd_' + idx"
                v-model="vo.pkgCd"
                @change="cntrCheckValidationInfo('cntrPkgCd_' + idx)"
              >
                <option value="">{{ $t('msg.CSBL220.003') }}</option>
                <option v-for="(pvo, i) in pkgCdList" :key="'cntrPkgCd_' + idx + '_' + i" :value="pvo.cd">{{ pvo.cdNm }}</option>
              </select>
            </td>
            <td>
              <button
                v-show="!closeCntr"
                class="tbl_icon minus"
                @click="removeBLContainer(idx)"
              >
                minus
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</template>

<script>
import { rootComputed } from '@/store/helpers'
import commons from '@/api/services/commons'
import trans from '@/api/rest/trans/trans'
import transCommon from '@/api/rest/trans/transCommon'
import schedule from '@/api/rest/schedule/schedule'
import BookingScheduleInfo from '@/components/trans/BookingScheduleInfo'
import EInputNumber from '@/components/common/EInputNumber'
import EDatePicker from '@/components/common/EDatePicker'
import ETransStringCheckInput from '@/components/trans/ETransStringCheckInput'
import ETransAddressInput from '@/components/trans/ETransAddressInput'
import ETransAddressTextarea from '@/components/trans/ETransAddressTextarea'
import ETransStringCheckCneeInput from '@/components/trans/ETransStringCheckCneeInput'
import ETextareaLineColumn from '@/components/common/ETextareaLineColumn'
import commonUtils from '@/plugins/commonUtils'
import blAttach from '@/api/rest/trans/blAttach'
//
import ETextarea from '@/components/common/ETextarea'

import ETextarea2 from '@/components/common/ETextarea2'
export default {
  name: 'WorkingHouseBlCargoInfo',
  components: {
    ETextarea,
    ETextarea2,
    //
    BookingScheduleInfo,
    EInputNumber,
    EDatePicker,
    ETransStringCheckInput,
    ETransAddressInput,
    ETransAddressTextarea,
    ETransStringCheckCneeInput,
    ETextareaLineColumn
  },
  props: {
    parentInfo: {
      type: Object,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      cstInfoList: [],
      lang: '',
      usrCtrCd: '',
      cstCatCd: '',
      blgPlcCd: '',
      saveFlag: 'BL_EDIT',
      selectBeforeVal: '',
      commonCodes: {},
      plcEnmCodes: {},
      cstEnmCodes: {},
      ctrCdList: [],
      ctrCdIccList: [],
      actCstIdList: [],
      cneCstIdList: [],
      notiCstIdList: [],
      cgoTypCdList: [],
      cntrRfStsList: [],
      issPlcList: [],
      frtPayPlcList: [],
      topMarkList: [],
      topDscrList: [],
      blEdiTypCdList: [],
      blPhbtList: [],
      deckCdList: [],
      pkgCdList: [],
      indiaCityList: [],
      blCopyOpen: 'N',
      blRequestOpen: 'N',
      vgmPopOpen: 'N',
      addrStr: '',
      isPolHsMulti: false,
      isPodHsMulti: false,
      saveCntrCnt: 1,
      customComponent: null,
      popParams: {},
      selectFunc: {},
      commonBLComponent: null,
      commonBLParams: {},
      commonBLCallback: null,
      freeTime: '',
      dscrStr: '',
      byStr: '',
      timeFlag: '',
      elDateFlag: '',
      blDetailDis: '',
      descrCaYn: '',
      cgoRest: '',
      closeEl: false, // E/L 정보 수정 불가 여부
      closeCntr: false, // 컨테이너 정보 수정 불가 여부
      rfDisabled: false,
      uploadFile: true,
      isBlAdd: true,
      isShipperLOI: false,
      isShipperLOIPlc: true, // Shipper LOI 첨부 가능지역여부
      excelUploadShow: true,
      saveShipperLOI: '',
      phbtAlertMsg: [],
      originParams: {},
      originCntrLen: 0, // 조회됐을때 컨테이너 Length. (originParams는 1차 가공된 정보라서 별도 변수 생성)
      pkgInfo: '',
      docPicNo: '',
      hsChkParams: {
        maxlengthPolHsCd: '6',
        maxlengthPodHsCd: '6',
        hscdPolErrorMessage: '',
        hscdPodErrorMessage: '',
        polCtrCd: '',
        podCtrCd: '',
        polSuccYn: '',
        podSuccYn: ''
      },
      regParams: {
        bkgNo: '',
        fwdrBlNo: '',
        blNo: '',
        ntfyNatlId: '', // 도착국가 : 이란
        porPlcNm: '', // Place of Receipt
        polPortNm: '', // Port of Loading
        podPortNm: '', // Port of Discharge
        dlyPlcNm: '', // Place of Delivery
        lstDestPlcNm: '', // Final Destination
        grsCbm: '',
        grsWt: '',
        pkgCd: '',
        hsCd: '',
        podHsCd: '',
        podHsNm: '',
        machineRmk: '',
        blTypCd: '',
        orgBlTypCd: '',
        exportLicenseList: [],
        containerList: [],
        houseBlDescList: []
      },
      updateBLParams: {
        blMaster: [],
        mrkMaster: [],
        cntrMaster: [],
        liceMaster: []
      },
      uploadFileList: [],
      timer: null,
      sayChk: true,
      vueMode: true, //process.env.VUE_APP_MODE !== 'PRD'
      autoSayYn: 'N',
      checkCgoType: 'Y',
      blTypeVisibleContry: [],
      orderYn: false,
      cntrNoArr: []
    }
  },
  computed: {
    ...rootComputed
  },
  watch: {

  },
  mounted () {
    if (this.regParams.caYn === 'Y') {
      $('#frm_cargo input,#frm_cargo select,#frm_cargo .plus,#frm_cargo .minus,#frm_cargo textarea').prop('disabled', true)
    }
  },
  created () {
    this._ = require('lodash')

    if (this.auth !== undefined) {
      this.cstCatCd = this.auth.cstCatCd
    }

    this.init()
  },
  methods: {
    async init () {
      this.regParams = this.parentInfo.houseBlList
      this.hsChkParams = this.parentInfo.hsChkParams

      // 01099 : 수출신고필증
      // 01032 : OCEAN FREIGHT 종류
      // 01130 : OCEAN FREIGHT 종류
      // 01031 : 컨테이너 사이즈
      // 01068 : 컨테이너 타입
      // 01033 : POD SHIPPING TERM
      // 01038 : DG
      // 01278 : 요청사항
      // CS038 : 인도 STATE
      const arrCdId = ['01130', '01208', 'EQ051']
      await commons.getCommonsCodesCommon(arrCdId).then(res => {
        this.commonCodes = res

        const pkgCdList = this.commonCodes['01130']
        const deckCdList = this.commonCodes['01208']

        pkgCdList.sort((a, b) => {
          return a.cdNm < b.cdNm ? -1 : a.cdNm > b.cdNm ? 1 : 0
        })

        this.pkgCdList = pkgCdList
        this.deckCdList = deckCdList
      })

      let newPkgCdList = []
      //pkgCd에서 containers = 25, pallets = 61 삭제
      //if (this.parentInfo.dlyCtrCd === 'US') {
        newPkgCdList = this.pkgCdList.filter(pkgCd => pkgCd.cd !== '25' && pkgCd.cd !== '61')
        this.pkgCdList = newPkgCdList
      //}

      // 컨테이너 초기화 (기존 ContainerInfo.init 로직 이동)
      if (this.$ekmtcCommon.isEmpty(this.regParams.houseBlContainerList)) {
        this.regParams.houseBlContainerList = []
      }
      console.log(this.regParams.houseBlContainerList)
      this.regParams.houseBlContainerList.forEach(data => {
        this.cntrNoArr.push(data.cntrNo)
        if (data.pkgCd === undefined || data.pkgCd === null) this.$set(data, 'pkgCd', '')
        // HS Code 관련 필드 보정 (서버 로드 행 대응)
        if (data.hsCd === undefined) this.$set(data, 'hsCd', '')
        if (data.hsCdNm === undefined) this.$set(data, 'hsCdNm', '')
        if (data.hsCdErrorMessage === undefined) this.$set(data, 'hsCdErrorMessage', '')
        if (data.hsCdSuccYn === undefined) this.$set(data, 'hsCdSuccYn', 'Y')
      })

      console.log('$$$$$$$$$$$$$$$$$$$$$$')
      console.log(this.cntrNoArr)

      if (this.regParams.houseBlContainerList.length === 0) {
        this.regParams.houseBlContainerList.push({
          cntrNo: '',
          blNo: this.regParams.blNo,
          fwdrBlNo: this.regParams.fwdrBlNo,
          grsCbm: '',
          wt: '',
          pkgQty: '',
          pkgCd: '',
          hsCd: '',
          hsCdNm: '',
          hsCdErrorMessage: '',
          hsCdSuccYn: 'Y'
        })
      }
    },
    sendCargoInfo () {
      return this.regParams
    },
    // WorkingSR/BL 에 입력된 해당 컨테이너의 Seal No. 목록(표시 전용). 없으면 빈 칸 1개
    getSealList (cntrNo) {
      const cntrList = this.parentInfo.parentRegParams.containerList || []
      const cntrInfo = cntrList.find(c => c.cntrNo === cntrNo)
      const sealList = ((cntrInfo && cntrInfo.sealList) || []).filter(s => this.$ekmtcCommon.isNotEmpty(s.sealNo))

      return sealList.length > 0 ? sealList : [{ sealNo: '' }]
    },
    addBLContainer () {
      let obj = {
        cntrNo: '',
        blNo: this.regParams.blNo,
        fwdrBlNo: this.regParams.fwdrBlNo,
        grsCbm: '',
        wt: '',
        pkgQty: '',
        pkgCd: '',
        hsCd: '',
        hsCdNm: '',
        hsCdErrorMessage: '',
        hsCdSuccYn: 'Y'
      }

      this.regParams.houseBlContainerList.push(obj)
    },
    removeBLContainer (idx) {
      let cntrNo = this.regParams.houseBlContainerList[idx].cntrNo
      const index = this.cntrNoArr.indexOf(cntrNo)
      if (index > -1) {
        this.cntrNoArr.splice(index, 1) // 인덱스 위치에서 1개 삭제
      }
      //내일와서 이부분확인해야함 현재 저장되어있는 리스트를 init 할때 cntrNoArr 에 넣어놓고 팝업에서 같은 컨테이너 선택시 중복선택이라는 알림창 노출중인데
      //remove 하고 다시 생성해도 알림창이 노출되어서 remove 할때 cntrNoArr 에서 삭제하는 로직 추가했는데 저장할때 에러날거임
      //어떻게해야할지 고민좀해봐야할듯.
      //지금 까지는 remove 하고 저장하고 다시 팝업 열어서 입력하고 저장했나 ?;;
      //일단 확인해보니 처음 저장하거나 제출할때는 trans 에 insertSR 을 호출하고
      //두번째부터는 updateSR 인데
      //첫번째는 어차피 없으니까 상관없을거같고
      //두번째부터는 updateSR 보니까 editSR 에서 houseBl 다 삭제하고 insert 하고있어서 상관없을거 같기도함. 내일와서 고민해봐~

      this.regParams.houseBlContainerList.splice(idx, 1)
      if (this.regParams.houseBlContainerList.length === 0) {
        this.addBLContainer()
      }
    },
    async checkCntrNo (idx) {
      if (this.auth !== undefined && this.auth.userId === 'CKLINE') {
        return
      }
      const regParams = this.regParams
      const containerInfo = regParams.houseBlContainerList[idx]
      let cntrNo = containerInfo.cntrNo
      const frm = document.querySelector('#frm_cargo')

      if (cntrNo.length === 0) {
        return
      }

      let duplicateYn = false
      this.regParams.houseBlContainerList.forEach((data, index) => {
        console.log(data.cntrNo)
        console.log(cntrNo)
        if (idx !== index && data.cntrNo.indexOf(cntrNo) > -1 && cntrNo !== 'select') {
          duplicateYn = true
        }
      })
      if (duplicateYn) {
          this.$ekmtcCommon.alertDefault('컨테이너 번호가 중복입니다.')
          regParams.houseBlContainerList[idx].cntrNo = 'select'
          regParams.houseBlContainerList[idx].grsCbm = ''
          regParams.houseBlContainerList[idx].pkgQty = ''
          regParams.houseBlContainerList[idx].pkgCd = ''
          regParams.houseBlContainerList[idx].wt = ''
          regParams.houseBlContainerList[idx].hsCd = ''
          regParams.houseBlContainerList[idx].hsCdNm = ''
          return
      }

      if (cntrNo.length < 11) {
        this.$ekmtcCommon.alertCallback(this.$t('msg.CSBL200.195'), () => {
          containerInfo.cntrNo = ''
          frm.querySelector('#cntrNo_' + idx).focus()
        })
        return
      }

      if (this.cstCatCd === 'Y' || regParams.shprVanYn === 'Y') {
        const regParams = this.regParams
        const containerInfo = regParams.houseBlContainerList[idx]
        const cntrNo = containerInfo.cntrNo
        const frm = document.querySelector('#frm_cargo')

        const arrCntrPrefix = this.commonCodes.EQ051
        let iranPrefix = 0
        arrCntrPrefix.forEach(p => {
          if (cntrNo.indexOf(p.cd) > -1) {
            iranPrefix++
          }
        })

        if (iranPrefix > 0) {
          this.$ekmtcCommon.alertCallback(this.$t('msg.CSBL200.196') + ' ' + cntrNo, () => {
            containerInfo.cntrNo = ''
            frm.querySelector('#cntrNo_' + idx).focus()
          })
        }
      } else {
        const dlyPlcCd = regParams.dlyPlcCd

        if ((dlyPlcCd === 'BJO' || dlyPlcCd === 'LUU' || dlyPlcCd === 'ROQ') &&
          (cntrNo.startsWith('MAXU') || cntrNo.startsWith('INNU') || cntrNo.startsWith('IRNU') || cntrNo.startsWith('RALU'))) {
          this.$ekmtcCommon.alertCallback(this.$t('msg.CSBL200.160'), () => {
            containerInfo.cntrNo = ''
            frm.querySelector('#cntrNo_' + idx).focus()
          })
        }

        let succFlag = true
        let result = null
        transCommon.findCntrInfo(cntrNo).then(res => {
          if (res.headers.respcode === 'C0000') {
            result = res.data
          } else {
            succFlag = false
          }
        }).catch(() => {
          succFlag = false
        }).finally(async () => {
          if (succFlag && result !== null && result !== undefined) {
            const cntrSzCd = result.cntrSzCd
            const cntrTypCd = result.cntrTypCd

            if (this.$ekmtcCommon.isNotEmpty(cntrSzCd)) {
              containerInfo.cntrSzCd = cntrSzCd
              containerInfo.cntrTypCd = cntrTypCd
              //외부에서 받아온 default 값 같이 세팅해줘야함.
              for (const item of this.parentInfo.parentRegParams.containerList) {
                if (item.cntrNo === cntrNo) {
                  containerInfo.pkgQty = item.pkgQty
                  containerInfo.grsCbm = item.meaCbm
                  containerInfo.wt = item.wt
                  containerInfo.hsCd = item.usHsCd
                  containerInfo.hsCdNm = ''
                  if (item.usHsCd) {
                    await this.checkHsCd(item.usHsCd, idx)
                  }
                }
              }
            } else {
              this.fnResetContainer(containerInfo, idx)
            }
          } else {
            this.fnResetContainer(containerInfo, idx)
          }
        })
      }
    },
    fnResetContainer (containerInfo, idx) {
      const frm = document.querySelector('#frm_cargo')
      this.$ekmtcCommon.alertDefault(this.$t('art.CMATK088') + this.$t('tem.CMAT006'))
      containerInfo.cntrSzCd = ''
      containerInfo.cntrTypCd = ''
      containerInfo.cntrNo = ''
      containerInfo.pkgQty = ''
      containerInfo.pkgCd = ''
      containerInfo.grsCbm = ''
      containerInfo.wt = ''
      frm.querySelector('#cntrNo_' + idx).focus()
    },
    cntrCheckValidationInfo (id, idx) {
      let isOk = true
      const frm = document.querySelector('#frm_cargo')
      const selector = frm.querySelector('#' + id)
      const regParams = this.regParams

      this.$ekmtcCommon.hideErrorTooltip(selector)

      if (id === 'blPrtSntcCont') {
        if (this.$ekmtcCommon.isNotEmpty(selector.value)) {
          if (this.regParams.blPrtSntcCont.length > 57) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200.207'))
            isOk = false
          }
        } else if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        }
      } else if (id === 'grsWt') {
        if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        } else {
          //SR 1428093 콜롬보향 중량 소수점 2자리 처리
          if (this.regParams.podPortCd === 'CMB') {
            if (selector.value.indexOf('.') > -1) {
              if (selector.value.substring(selector.value.indexOf('.') + 1).length > 2) {
                this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.550'))
                isOk = false
              }
            }
          }
        }
      } else if (id.indexOf('wt') === 0) {
        //SR 1428093 콜롬보향 중량 소수점 2자리 처리
        if (this.regParams.podPortCd === 'CMB') {
          if (selector.value.indexOf('.') > -1) {
            if (selector.value.substring(selector.value.indexOf('.') + 1).length > 2) {
              this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.550'))
              isOk = false
            }
          }
        }
      } else if (id.indexOf('grsCbm') === 0) {
        // if (this.regParams.podCtrCd === 'BH' || this.regParams.dlyCtrCd === 'MX') {
          if (Number(this.regParams.grsCbm) <= 0) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.238'))
            isOk = false
          }
        // }
      } else {
        if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        }
      }

      return isOk
    },
    cntrFnPackage (actionFlag) {
      const regParams = this.regParams
      const pkgQty = regParams.pkgQty

      let retValue = ''

      let flagChange = 'N'
      let cc = ''
      let dd = 0
      let jj = ''
      let kk = ''

      const dscr = this.regParams.markDescList[0].dscr
      regParams.markDescList[0].dscr = dscr.replace(this.pkgInfo, '')

      if (this.$ekmtcCommon.isNotEmpty(pkgQty)) {
        retValue = this.$ekmtcCommon.changeNumberFormat(pkgQty, { isComma: true })
      }

      const arrDscr = dscr.split('\n')
      arrDscr.forEach((d, i) => {
        if ((d.indexOf('X20') !== -1 || d.indexOf('X40') !== -1 || d.indexOf('X45') !== -1 ||
             d.indexOf('X 20') !== -1 || d.indexOf('X 40') !== -1 || d.indexOf('X 45') !== -1)) {
          cc += d + '\n'
          ++dd
        } else {
          if (parseInt(d.trim().substring(0, 5).charAt(0)) >= 0 && parseInt(d.trim().substring(0, 5).charAt(0)) <= 9) {
            // Package 수량 체크는 2번째 라인까지만 확인
            if (i < 3 && flagChange === 'N') {
              regParams.markDescList[0].dscr = dscr.replace(d, retValue)
              flagChange = 'Y'
            } else {
              jj += d
            }
          } else {
            jj += d
          }
          if (i !== (arrDscr.length - 1)) {
            jj += '\n'
          }
        }
      })

      if (arrDscr.length === dd) {
        kk = cc + retValue
      } else {
        kk = cc + retValue + jj
      }

      regParams.markDescList[0].dscr = kk
    },
    checkValidationInfo (id) {
      let isOk = true
      const frm = document.querySelector('#frm_cargo')
      const selector = frm.querySelector('#' + id)
      const regParams = this.regParams

      this.$ekmtcCommon.hideErrorTooltip(selector)

      if (id === 'blPrtrCont') {
        if (this.$ekmtcCommon.isNotEmpty(selector.value)) {
          if (this.regParams.blPrtrCont.length > 57) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200.207'))
            isOk = false
          }
        } else if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        }
      } else if (id === 'hsCd') {
        if ((regParams.cgoModeCd === '01' || regParams.cgoModeCd === '03') && this.$ekmtcCommon.isEmpty(selector.value)) {
          // POL 국가별 체크
          if (regParams.polCtrCd === 'ID' || regParams.polCtrCd === 'MY' || regParams.polCtrCd === 'IN') {
            this.hsChkParams.hscdPolErrorMessage = ''
            this.$nextTick(() => { this.hsChkParams.hscdPolErrorMessage = this.$t('msg.CSBK100.147') })
            isOk = false
          }
          // POL 태국, POD 특정 포트 체크
          if (regParams.polCtrCd === 'TH' && (regParams.podPortCd === 'JEA' || regParams.podPortCd === 'SOH')) {
            this.hsChkParams.hscdPolErrorMessage = ''
            this.$nextTick(() => { this.hsChkParams.hscdPolErrorMessage = this.$t('msg.CSBK100.147') })
            isOk = false
          }
        }
      } else if (id === 'grsWt') {
        if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        } else {
          //SR 1428093 콜롬보향 중량 소수점 2자리 처리
          if (this.regParams.podPortCd === 'CMB') {
            if (selector.value.indexOf('.') > -1) {
              if (selector.value.substring(selector.value.indexOf('.') + 1).length > 2) {
                this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.550'))
                isOk = false
              }
            }
          }
        }
      } else if (id.indexOf('wt') === 0) {
        //SR 1428093 콜롬보향 중량 소수점 2자리 처리
        if (this.regParams.podPortCd === 'CMB') {
          if (selector.value.indexOf('.') > -1) {
            if (selector.value.substring(selector.value.indexOf('.') + 1).length > 2) {
              this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.550'))
              isOk = false
            }
          }
        }
      } else if (id === 'grsCbm') {
        // 테스트 끝나면 주석 해제
        if (this.regParams.podCtrCd === 'BH' || this.regParams.dlyCtrCd === 'MX') {
          if (Number(this.regParams.grsCbm) <= 0) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.238'))
            isOk = false
          }
        }
      } else {
        if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        }
      }

      return isOk
    },
    fnPackage (actionFlag) {
      const regParams = this.regParams
      const pkgQty = regParams.pkgQty
      const pkgCd = regParams.pkgCd

      const pkgInfo = this.commonCodes['01130'].filter(vo => vo.cd === pkgCd)[0]

      let retValue = ''
      let pkgNm = ''

      if (pkgInfo !== undefined) {
        pkgNm = pkgInfo.cdNm
      }

      let flagChange = 'N'
      let cc = ''
      let dd = 0
      let jj = ''
      let kk = ''

      const dscr = this.regParams.houseBlDescList[0].dscr
      this.regParams.houseBlDescList[0].dscr = dscr.replace(this.pkgInfo, '')

      if (this.$ekmtcCommon.isNotEmpty(pkgQty) && this.$ekmtcCommon.isNotEmpty(pkgCd)) {
        retValue = this.$ekmtcCommon.changeNumberFormat(pkgQty, { isComma: true }) + pkgNm
      }

      const arrDscr = dscr.split('\n')
      arrDscr.forEach((d, i) => {
        if ((d.indexOf('X20') !== -1 || d.indexOf('X40') !== -1 || d.indexOf('X45') !== -1)) {
          cc += d + '\n'
          ++dd
        } else {
          if (parseInt(d.substring(0, 5).charAt(0)) >= 0 && parseInt(d.substring(0, 5).charAt(0)) <= 9) {
            // Package 수량 체크는 2번째 라인까지만 확인
            if (i < 3 && flagChange === 'N') {
              regParams.houseBlDescList[0].dscr = dscr.replace(d, retValue)
              flagChange = 'Y'
              /*
              if (d.indexOf('X20') === -1 && d.indexOf('X40') === -1 && d.indexOf('X45') === -1 && d !== this.pkgInfo) {
                jj += d.replace(this.pkgInfo, '')
              } */
            } else {
              jj += d
            }
          } else {
            jj += d
          }
          if (i !== (arrDscr.length - 1)) {
            jj += '\n'
          }
        }
      })

      if (arrDscr.length === dd) {
        kk = cc + retValue
      } else {
        kk = cc + retValue + jj
      }

      regParams.houseBlDescList[0].dscr = kk
    },
    checkErrorVisible (id) {
      const frm = document.querySelector('#frm_cargo')
      const elem = frm.querySelector('#' + id)

      const parentElem = $(elem).parents('td, div').eq(0)
      const msgBox = parentElem.find('.tooltip_essen_box').eq(0)

      if (msgBox.length > 0 && msgBox.is(':visible') && this.$ekmtcCommon.isNotEmpty(elem.value)) {
        this.$ekmtcCommon.hideErrorTooltip(elem)
      }
    },
    // 컨테이너별 HS Code 검증 (행별 상태) — WorkingSR.checkUsHsCd 동일 방식
    async checkHsCd (e, idx) {
      const vo = this.regParams.houseBlContainerList[idx]
      const val = (e || '').replace(/,/g, '')

      // 빈 값 → 에러툴팁 해제, 명칭 비움 (필수 여부는 부모 제출검증에서 처리)
      if (val === '') {
        this.$set(vo, 'hsCdErrorMessage', '')
        this.$set(vo, 'hsCdNm', '')
        this.$set(vo, 'hsCdSuccYn', 'Y')
        return
      }

      let isOk = true
      const message = this.$t('msg.CSBL200.175')

      // US 6자리 고정
      if (/[^0-9]/g.test(val) || isNaN(parseInt(val))) {
        isOk = false
      } else if (val.length !== 6) {
        isOk = false
      }

      if (isOk) {
        // 서버검증 (fnHsCdValidation 로직 유지)
        isOk = await this.fnHsCdValidation(val, idx)
      } else {
        // 형식 오류면 명칭 비움
        this.$set(vo, 'hsCdNm', '')
      }

      // 에러 있으면 툴팁 표시 / 없으면 해제
      this.$set(vo, 'hsCdErrorMessage', isOk ? '' : message)
      this.$set(vo, 'hsCdSuccYn', isOk ? 'Y' : 'N')
    },
    // 서버 HS Code 검증 — 기존 로직 유지, 입력만 파라미터화
    async fnHsCdValidation (hsCd, idx) {
      let isOk = true
      let checkType = 'US'
      let podCtrCd = 'US'

      await transCommon.getHscdValidation({
        hsCd: hsCd,
        hsFlag: checkType,
        podCtrCd: podCtrCd,
        hsNmSearchYn: 'Y'
      }).then(res => {
        const result = res.data
        if (idx !== undefined && this.regParams.houseBlContainerList[idx]) {
          this.$set(this.regParams.houseBlContainerList[idx], 'hsCdNm', result.hsNm || '')
        }
        if (result.returnFlag === 'N') {
          isOk = false
        }
      })

      return isOk
    },
    // 컨테이너 HS Code 일괄 검증 (제출용)
    checkValidationHsCd () {
      return !this.regParams.houseBlContainerList.some(
        vo => this.$ekmtcCommon.isEmpty(vo.hsCd) || vo.hsCdSuccYn === 'N'
      )
    },
    searchAgentAddr () {
      this.popParams = {}
      if (this.$ekmtcCommon.isNotEmpty(this.addrStr)) {
        const ctrCd = this.addrStr.split(':')[0]
        const plcCd = this.addrStr.split(':')[1]
        this.popParams.addrCtrCd = ctrCd
        this.popParams.addrPlcCd = plcCd
      }

      this.selectFunc = ''
      this.openPopup('bl-agent-address-pop')
    },
    selectAgentAddr (vo) {
      if (vo !== undefined) {
        const markDescList = this.regParams.markDescList

        markDescList[0].mrk = vo.sntcCont.trim()
        this.closePopup()
      }
    }
  }
}
</script>
<style scoped>
  .tooltip_wrap .cont {padding: 20px;}
  .div_tooltip {width:230px !important; right:0; top:24px;}
  .tooltip_wrap {width:150px; right:0; top:24px; display:none;}
  .txt_desc {background: inherit; position: relative;}
  .txt_desc:before {content:'※'; position: absolute; top: 0; left: 0;}
  .minus {background-position: -50px -50px;}
  .div_seal+.div_seal {margin-top: 5px;}
  .tbl_mark td{vertical-align: top;}
  .txt_desc1 {min-height: inherit; height: 45px; overflow: hidden; font-family: 'Courier New'; padding-top: 2px;}
  .txt_underline {font-weight: 500; text-decoration: underline; color: inherit; cursor: pointer;}
  .td_noline {border-left: none; border-bottom: none;}
  .tbl_btm_none {border-bottom: none !important;}
  .line_bottom {border-bottom: 1px solid #e1e3eb;}
  .no_cursor {cursor: default;}
  .no_cursor:hover { color:#5e75bf !important; border: solid 1px #a2aed2 !important;}
  .deck_select {
    border: solid 0px #cecece !important;
    color: black;
    background: white !important;
    padding: 0 0 0 0;
  }
</style>
